import './ButtonTypeOutlineTextIcon.scss';